(function() {
  "use strict";

  const selectors = {
    modal: '.csh-aem-base-modal',
    iframeYoutube: '.csh-aem-base-youtube__frame',
  };

  const addModalCloseEvent = () => {
    let modal = document.querySelector(selectors.modal);
    modal?.addEventListener('hidden.bs.modal', () => {
        let iframe = document.querySelector(selectors.iframeYoutube);
        iframe.src = iframe.src;
    });
  };

  const onDocumentReady = () => {
    addModalCloseEvent();
  };

  if (document.readyState !== "loading") {
    onDocumentReady();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentReady);
  }

}());